import { render, staticRenderFns } from "./Followtestdetail.vue?vue&type=template&id=80f1f360&scoped=true"
import script from "./Followtestdetail.vue?vue&type=script&lang=js"
export * from "./Followtestdetail.vue?vue&type=script&lang=js"
import style0 from "./Followtestdetail.vue?vue&type=style&index=0&id=80f1f360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f1f360",
  null
  
)

export default component.exports